import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Select from 'react-select';
import { Table } from "antd";
import { BeatLoader } from "react-spinners";
// import Pagination from '../../Pagination';
import Skeleton from "react-loading-skeleton";
import { Tooltip } from "antd";
import AddMaster from "./AddMaster";
import EditMaster from "./EditMaster";
// import { adminMainUrl } from '../../../Config';
// import { DesignationApi } from '../../../Redux/action/MasterAction';
import { Code } from "@mui/icons-material";
import ReactTooltip from "react-tooltip";
import { adminMainUrl } from "../../../../../Config";
import { DesignationApi } from "../../../../../Redux/action/MasterAction";
// import { DesignationApi } from '../../../../Redux/action/MasterAction';
// import { adminMainUrl } from '../../../../Config';

const Drawback = ({ accessedModules, accessedPermission }) => {
  const [currentData, setCurrentData] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [dataOffset, setDataOffset] = useState(0);
  const dataPerPage = 10;
  const [reload, setReload] = useState(false);
  const [spinnerLoader, setSpinnerLoader] = useState(false);
  const [DesignationName, setDesignationName] = useState(null);
  const [DesignationId, setDesignationId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; // Number of items per page
  // const { name } = useParams();
  const dispatch = useDispatch();
  const {
    loadingDesignationTypeApi,
    findDesignationTypeData, 
    findDesignationTypeDataError,
  } = useSelector((state) => state?.MasterReducer);
  useEffect(() => {
    dispatch(DesignationApi(adminMainUrl));
  }, [adminMainUrl, reload]);
  const handleSuccess = () => {
    // Toggle reload to trigger useEffect
    setReload((prev) => !prev);
  };

  // Initialize Formik
  const statusChange = async (id) => {
    setSpinnerLoader(true);
    try {
      const response = await fetch(
        `${adminMainUrl}/api/designation/status-change`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "auth-token": Cookies.get("token"), // Assuming token is stored in cookies
          },
          body: JSON.stringify({ id: id.toString() }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        setSpinnerLoader(false);
        handleSuccess(); // Call the success handler
        toast.success(data?.msg);
      } else {
        setSpinnerLoader(false);
        toast.error(data?.msg);
      }
    } catch (error) {
      setSpinnerLoader(false);
      console.error("Network error:", error);
    }
  };

  const handleChange = (id) => {
    // if (accessedPermission.includes("state_change_master_data")) {
    statusChange(id);
    // }
  };
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = findDesignationTypeData?.data;

  const totalPages = Math.ceil(
    findDesignationTypeData?.data?.length / itemsPerPage
  );

  // Function to change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Function for "Next" and "Previous" buttons
  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  const arr = new Array(5).fill(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  // const columns = [
  //     { title: "Request No.", dataIndex: "requestNo", key: "requestNo" },
  //     { title: "Date", dataIndex: "date", key: "date" },
  //     { title: "Name", dataIndex: "name", key: "name" },
  //     { title: "Email", dataIndex: "email", key: "email" },
  //     { title: "Phone Number", dataIndex: "phoneNumber", key: "phoneNumber" },
  //     { title: "Origin", dataIndex: "origin", key: "origin" },
  //     { title: "Destination", dataIndex: "destination", key: "destination" },
  //     { title: "Shipment Type", dataIndex: "shipmentType", key: "shipmentType" },
  //     { title: "Shipment Via", dataIndex: "shipmentVia", key: "shipmentVia" },
  //     { title: "Picked By", dataIndex: "pickedBy", key: "pickedBy" },
  //     { title: "Action", dataIndex: "action", key: "action" },
  // ];
  const [editshow, setEditShow] = useState(false);
  const handleEditClose = () => setEditShow(false);
  const handleEditShow = () => setEditShow(true);
  const columns = [
    { title: "S. No.", dataIndex: "SNo", key: "SNo" },
    { title: "Dbk Sr. No.", dataIndex: "NotnNo.", key: "NotnNo." },
    { title: "Description", dataIndex: "SerialNo", key: "SerialNo" },
    { title: "Dbk Rate %", dataIndex: "Rate", key: "Rate" },
    { title: "Dbk CAP Rs", dataIndex: "CVDDuty", key: "CVDDuty" },
    { title: "Dbk Unit", dataIndex: "ApplFor", key: "ApplFor" },
    { title: "Status", dataIndex: "Status", key: "Status" },
    { title: "Action", dataIndex: "action", key: "action" },
  ];

  const dataSource = [
    {
      key: "1", // Add a unique key for each row
      SNo: "1", // Changed to camelCase

      Status: (
        <>
          <span
            className={`cursor-pointer  badge badge-pill badge-status bg-success   `}
          >
            Active
          </span>

          {/* <div className="form-check form-switch d-flex justify-content-center">
          <div
              type="button"
              data-bs-toggle="tooltip"
              data-bs-placement="bottom"
              title={value.status === true ? "active" : "inactive"}
          >
              <input
                  className="form-check-input"
                  type="checkbox"
                  id={`flexSwitchCheckChecked-${i}`}
                  checked={value.status === true}
                  onChange={() => handleChange(value.id)}
              />
          </div>
      </div> */}
        </>
      ),
      action: (
        <div className="dropdown table-action">
          <Link to="#" className="action-icon" data-bs-toggle="dropdown">
            <i className="fa fa-ellipsis-v"></i>
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <div
              className="dropdown-item cursor-pointer"
              onClick={handleEditShow}
            >
              <i className="ti ti-edit text-blue me-2"></i> Edit
            </div>
          </div>
        </div>
      ),
    },
    {
      key: "1", // Add a unique key for each row
      SNo: "1", // Changed to camelCase
      NotnNo: "", // Ensure date formatting as neede
      SerialNo: "",
      TariffHeading: "",
      Rate: "",

      ApplFor: "",

      Status: (
        <>
          <span
            className={`cursor-pointer  badge badge-pill badge-status bg-success   `}
          >
            Active
          </span>

          {/* <div className="form-check form-switch d-flex justify-content-center">
          <div
              type="button"
              data-bs-toggle="tooltip"
              data-bs-placement="bottom"
              title={value.status === true ? "active" : "inactive"}
          >
              <input
                  className="form-check-input"
                  type="checkbox"
                  id={`flexSwitchCheckChecked-${i}`}
                  checked={value.status === true}
                  onChange={() => handleChange(value.id)}
              />
          </div>
      </div> */}
        </>
      ),
      action: (
        <div className="dropdown table-action">
          <Link to="#" className="action-icon" data-bs-toggle="dropdown">
            <i className="fa fa-ellipsis-v"></i>
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <div
              className="dropdown-item cursor-pointer"
              onClick={handleEditShow}
            >
              <i className="ti ti-edit text-blue me-2"></i> Edit
            </div>
          </div>
        </div>
      ),
    },
  ];
  const [addShow, setAddShow] = useState(false);
  const handleAddClose = () => setAddShow(false);
  const handleAddShow = () => setAddShow(true);

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              {/* Page Header */}
              <div className="page-header">
                <div className="row align-items-center">
                  <div className="col-8">
                    <h4 className="page-title">
                    Drawback <span className="count-title">23</span>
                    </h4>
                  </div>
                  <div className="col-4 text-end">
                    <div className="head-icons">
                      <a
                        href="javascript:void(0);"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        data-bs-original-title="Collapse"
                        id="collapse-header"
                      >
                        <i className="ti ti-chevrons-up" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Page Header */}
            </div>
          </div>
          <div className="card">
            <div className="card-body">
              {/* Filter */}
              <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2 mb-1">
                <div className="d-flex align-items-center flex-wrap row-gap-2">
                  <div className="dropdown me-2">
                    <a
                      href="javascript:void(0);"
                      className="dropdown-toggle"
                      data-bs-toggle="dropdown"
                    >
                      <i className="ti ti-sort-ascending-2 me-2" />
                      Sort{" "}
                    </a>

                    <div className="dropdown-menu  dropdown-menu-start">
                      <ul>
                        <li>
                          <a
                            href="javascript:void(0);"
                            className="dropdown-item"
                          >
                            <i className="ti ti-circle-chevron-right me-1" />
                            Ascending
                          </a>
                        </li>
                        <li>
                          <a
                            href="javascript:void(0);"
                            className="dropdown-item"
                          >
                            <i className="ti ti-circle-chevron-right me-1" />
                            Descending
                          </a>
                        </li>
                        <li>
                          <a
                            href="javascript:void(0);"
                            className="dropdown-item"
                          >
                            <i className="ti ti-circle-chevron-right me-1" />
                            Recently Viewed
                          </a>
                        </li>
                        <li>
                          <a
                            href="javascript:void(0);"
                            className="dropdown-item"
                          >
                            <i className="ti ti-circle-chevron-right me-1" />
                            Recently Added
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="icon-form mb-3 mb-sm-0 me-2">
                    <span className="form-icon">
                      <i className="ti ti-search" />
                    </span>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      placeholder="Search "
                      name="search_by"
                    />
                  </div>
                  <div className="form-sorts dropdown ">
                    <Tooltip placement="top" title="Filter">
                      <a
                        href="javascript:void(0);"
                        data-bs-toggle="dropdown"
                        data-bs-auto-close="outside"
                        // className='py-1'
                        style={{
                          paddingTop: "7px",
                          paddingBottom: "6px",
                        }}
                      >
                        <i className="ti ti-filter-share me-0" />
                        {/* Filter */}
                      </a>
                    </Tooltip>
                    <div className="filter-dropdown-menu dropdown-menu  dropdown-menu-md-end p-3">
                      <div className="filter-set-view">
                        {/* <div className="filter-set-head">
                                                    <h4>
                                                        <i className="ti ti-filter-share" />
                                                        Filter
                                                    </h4>
                                                </div> */}
                        <table className="content-table">
                          <tbody>
                            <tr>
                              <td>
                                <label htmlFor="#">Dbk Sr. No.</label>
                              </td>
                              <td className="input_box_filter">
                              <input
                                  type="text"
                                  className="form-control form-control-sm ms-2"
                                  placeholder="Enter Name"
                                  name="request_no"
                                />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <label htmlFor="#">Description</label>
                              </td>
                              <td className="input_box_filter">
                                <input
                                  type="text"
                                  className="form-control form-control-sm ms-2"
                                  placeholder="Enter Name"
                                  name="request_no"
                                />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <div className="filter-reset-btns">
                          <div className="row">
                            <div className="col-6">
                              <a className="btn btn-light">Reset</a>
                            </div>
                            <div className="col-6">
                              <button
                                type="submit"
                                className="btn btn-primary w-100"
                              >
                                Filter
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <div className="icon-form">
                                        <span className="form-icon">
                                            <i className="ti ti-calendar" />
                                        </span>
                                        <input
                                            type="text"
                                            className="form-control bookingrange"
                                            placeholder=""
                                        />
                                    </div> */}
                </div>
                <div className="d-flex align-items-center flex-wrap row-gap-2">
                  <Tooltip placement="top" title="Print Data">
                    <div className="btn btn-primary cursor-pointer me-2">
                      <i className="ti ti-printer text-white"></i>
                      {/* <ReactTooltip id="print" place="top" effect="solid" /> */}
                    </div>
                  </Tooltip>
                  <Tooltip placement="top" title="Export Data">
                    <div className="btn btn-primary cursor-pointer me-2">
                      <i className="fas fa-file-export text-white"></i>
                      {/* <ReactTooltip id="export" place="top" effect="solid" /> */}
                    </div>
                  </Tooltip>
                  <button type="submit" className="btn btn-primary me-2">
                    Search
                  </button>
                  <a
                    className="btn btn-light me-2"
                    //   style={{ background: "#04aed2", marginTop: "7px", marginBottom: "15px" }}
                  >
                    Clear
                  </a>
                  <div
                    className="btn btn-primary cursor-pointer me-2"
                    onClick={handleAddShow}
                  >
                    <i className="ti ti-square-rounded-plus me-2" />
                    Add Drawback
                  </div>

                  {/* <div className="dropdown me-2">
                                        <a
                                            href="javascript:void(0);"
                                            className="btn bg-soft-purple text-purple"
                                            data-bs-toggle="dropdown"
                                            data-bs-auto-close="outside"
                                        >
                                            <i className="ti ti-columns-3 me-2" />
                                            Manage Columns
                                        </a>
                                        <div className="dropdown-menu  dropdown-menu-md-end dropdown-md p-3">
                                            <h4 className="mb-2 fw-semibold">Want to manage datatables?</h4>
                                            <p className="mb-3">
                                                Please drag and drop your column to reorder your table and
                                                enable see option as you want.
                                            </p>
                                            <div className="border-top pt-3">
                                                <div className="d-flex align-items-center justify-content-between mb-3">
                                                    <p className="mb-0 d-flex align-items-center">
                                                        <i className="ti ti-grip-vertical me-2" />
                                                        Name
                                                    </p>
                                                    <div className="status-toggle">
                                                        <input type="checkbox" id="col-name" className="check" />
                                                        <label htmlFor="col-name" className="checktoggle" />
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-3">
                                                    <p className="mb-0 d-flex align-items-center">
                                                        <i className="ti ti-grip-vertical me-2" />
                                                        Phone
                                                    </p>
                                                    <div className="status-toggle">
                                                        <input type="checkbox" id="col-phone" className="check" />
                                                        <label htmlFor="col-phone" className="checktoggle" />
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-3">
                                                    <p className="mb-0 d-flex align-items-center">
                                                        <i className="ti ti-grip-vertical me-2" />
                                                        Email
                                                    </p>
                                                    <div className="status-toggle">
                                                        <input type="checkbox" id="col-email" className="check" />
                                                        <label htmlFor="col-email" className="checktoggle" />
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-3">
                                                    <p className="mb-0 d-flex align-items-center">
                                                        <i className="ti ti-grip-vertical me-2" />
                                                        Tags
                                                    </p>
                                                    <div className="status-toggle">
                                                        <input type="checkbox" id="col-tag" className="check" />
                                                        <label htmlFor="col-tag" className="checktoggle" />
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-3">
                                                    <p className="mb-0 d-flex align-items-center">
                                                        <i className="ti ti-grip-vertical me-2" />
                                                        Location
                                                    </p>
                                                    <div className="status-toggle">
                                                        <input type="checkbox" id="col-loc" className="check" />
                                                        <label htmlFor="col-loc" className="checktoggle" />
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-3">
                                                    <p className="mb-0 d-flex align-items-center">
                                                        <i className="ti ti-grip-vertical me-2" />
                                                        Rating
                                                    </p>
                                                    <div className="status-toggle">
                                                        <input type="checkbox" id="col-rate" className="check" />
                                                        <label htmlFor="col-rate" className="checktoggle" />
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-3">
                                                    <p className="mb-0 d-flex align-items-center">
                                                        <i className="ti ti-grip-vertical me-2" />
                                                        Owner
                                                    </p>
                                                    <div className="status-toggle">
                                                        <input type="checkbox" id="col-owner" className="check" />
                                                        <label htmlFor="col-owner" className="checktoggle" />
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-3">
                                                    <p className="mb-0 d-flex align-items-center">
                                                        <i className="ti ti-grip-vertical me-2" />
                                                        Contact
                                                    </p>
                                                    <div className="status-toggle">
                                                        <input
                                                            type="checkbox"
                                                            id="col-contact"
                                                            className="check"
                                                            defaultChecked=""
                                                        />
                                                        <label htmlFor="col-contact" className="checktoggle" />
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between mb-3">
                                                    <p className="mb-0 d-flex align-items-center">
                                                        <i className="ti ti-grip-vertical me-2" />
                                                        Status
                                                    </p>
                                                    <div className="status-toggle">
                                                        <input
                                                            type="checkbox"
                                                            id="col-status"
                                                            className="check"
                                                        />
                                                        <label htmlFor="col-status" className="checktoggle" />
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between">
                                                    <p className="mb-0 d-flex align-items-center">
                                                        <i className="ti ti-grip-vertical me-2" />
                                                        Action
                                                    </p>
                                                    <div className="status-toggle">
                                                        <input
                                                            type="checkbox"
                                                            id="col-action"
                                                            className="check"
                                                        />
                                                        <label htmlFor="col-action" className="checktoggle" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}

                  {/* <div className="view-icons">
                                        <Link onClick={() => { setGrid(true) }} className={`${grid === true && "active"}`}>
                                            <i className="ti ti-list-tree" />
                                        </Link>
                                        <Link onClick={() => { setGrid(false) }} className={`${grid === false && "active"}`}>
                                            <i className="ti ti-grid-dots" />
                                        </Link>
                                    </div> */}
                </div>
              </div>
              {/* /Filter */}
              {/* Contact List */}

              {/* {
                                loadingDesignationTypeApi ?
                                    arr.map((value, index) => {
                                        return (

                                            <div className='d-flex justify-content-center align-items-center' style={{ height: "400px", width: "100%" }}>
                                            <BeatLoader />
                                        </div>
                                        )
                                    }) :
                                    spinnerLoader ?
                                        <>
                                            <div className='d-flex justify-content-center align-items-center' style={{ height: "400px", width: "100%" }}>
                                                <BeatLoader />
                                            </div>
                                        </> :
                                        <> */}
              <div className="table-responsive custom-table">
                <Table
                  className="table datanew dataTable no-footer"
                  pagination={false}
                  dataSource={dataSource}
                  columns={columns}
                />
              </div>

              {/* <Pagination data={currentItems} dataPerPage={dataPerPage} setDataOffset={setDataOffset} dataOffset={dataOffset} setPageCount={setPageCount} pageCount={pageCount} setCurrentData={setCurrentData} currentData={currentData} />
                                        </>
                            } */}
              {/* <div className="pagination-controls my-5 d-flex justify-content-center align-items-center">
                                <button
                                    className=''
                                    onClick={() => handlePageChange(count - 1)}
                                    disabled={count === 1}
                                >
                                    <img src="/img/right.png" className='mx-2' alt="right" />
                                </button>

                                {pageNumbers.map((number, index) =>
                                    number === '...' ? (
                                        <span key={index} className="mx-2">...</span>
                                    ) : (
                                        <span
                                            key={number}
                                            className={`search-btn-1 ${number === count ? 'active' : ''}`}
                                            onClick={() => handlePageChange(number)}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            {number}
                                        </span>
                                    )
                                )}

                                <button
                                    onClick={() => handlePageChange(count + 1)}
                                    disabled={count === totalPages}
                                >
                                    <img src="/img/left.png" className='mx-2' alt="right" />
                                </button>
                            </div> */}
            </div>
          </div>
        </div>
      </div>
      <AddMaster
        show={addShow}
        handleClose={handleAddClose}
        onSuccess={handleSuccess}
      />
      <EditMaster
        show={editshow}
        handleClose={handleEditClose}
        onSuccess={handleSuccess}
      />
      {/* <EditEmployee id="offcanvas_edit" />
            <AddEmployee id="offcanvas_add" /> */}
      {/* <CreateQuoteForm SentQuoteList={SentQuoteList} id="offcanvas_create" />

            <EditQuoteForm id="offcanvas_edit_form" QuotationId={id} ViewDetails={viewData} /> */}
    </>
  );
};

export default Drawback
